module.exports = __webpack_public_path__ + "media/images/riders/ANTON_SINTSOV-bdc6aadbf068b6c109f02d770076c37b.png";